/* Required jQuery initialization for select2 */
jQuery(document).ready(function($) {
    $('#recentApplicants').on('change', function () {
        if($('.card--recent-applicants-filter')) {
            $('.card--recent-applicants-filter').submit();
        }
    });

    $('.page-link').on('click', function (e) {
        e.preventDefault();

        let pageItem = $(this).attr('data-page');
        console.log(pageItem);

        $('#search-paged').val(pageItem);

        if($('.card--recent-applicants-filter')) {
            $('.card--recent-applicants-filter').submit();
        }
    });
});